var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportOverground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ada92b7e-4ff8-4011-9165-e00396a6b3bb",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308.9 254.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M178.74,226.87C190.89,196.08,220.9,173,256,173s65.11,23.1,77.26,53.89h46.31C365.92,171.3,315.78,128.76,256,128.76S146.08,171.3,132.43,226.87Z",
    transform: "translate(-101.55 -128.76)",
    style: {
      fill: "#e16710"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.26,285.13C321.11,315.92,291.1,339,256,339s-65.11-23.1-77.26-53.89H132.43c13.65,55.57,63.79,98.11,123.57,98.11s109.92-42.54,123.57-98.11Z",
    transform: "translate(-101.55 -128.76)",
    style: {
      fill: "#e16710"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.45,275.55a9.8,9.8,0,0,1-10,9.58H111.56a9.8,9.8,0,0,1-10-9.58v-39.1a9.8,9.8,0,0,1,10-9.58H400.44a9.8,9.8,0,0,1,10,9.58v39.1Z",
    transform: "translate(-101.55 -128.76)",
    style: {
      fill: "#27409b"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportOverground);
export default __webpack_public_path__ + "static/media/transport-overground.a3731137.svg";
export { ForwardRef as ReactComponent };